import React, { CSSProperties } from 'react';

interface DynamicImageIconInterface {
  imageName: string;
  alt: string;
  className?: string;
  style?: CSSProperties;
}

const DynamicImageIcon = ({ imageName, alt, className, style }: DynamicImageIconInterface) => {
  // let webpSrc = `${process.env.PUBLIC_URL}/assets/${imageName}.webp`;
  let pngSrc = '';

  if (imageName.includes('https://')) {
    // TODO UNCOMMENT
    // webpSrc = imageName.replace('.png', '.webp').replace('.jpg', '.webp');
    // webpSrc = imageName;
    pngSrc = imageName;
  } else {
    pngSrc = require(`shared/assets/png/${imageName || 'explora-logo'}.png`);
  }

  return (
    <picture>
      {/* <source type="image/webp" srcSet={webpSrc} /> */}
      <img src={pngSrc} className={className} style={style} alt={alt} />
    </picture>
  );
};

export default DynamicImageIcon;
